import PropTypes from 'prop-types';

import '../../../../../Wells/HeaderDetail/HeaderDetail.scss';

const HeaderDetailVE = ({ title }) => (
  <div className="d-flex justify-content-between">
    <div className="well-header-detail">
      <h6 className="me-2">Ubicación</h6>
      <h6 className="pill light">{title}</h6>
    </div>
  </div>
);

HeaderDetailVE.propTypes = {
  title: PropTypes.string.isRequired
};

export default HeaderDetailVE;
